// Actions
export const SET_COUNTRY = Symbol.for('locale.setCountry')
export const SET_LANGUAGE = Symbol.for('locale.setLanguage')

export const LOCALE_COUNTRY = 'country'
export const LOCALE_LANGUAGE = 'lang'
